import { getFocusSelector } from '@apia/util';
import { TResponsiveTableState } from '../store/types';

export function applyFocusAttributes(
  table: HTMLElement,
  _previousState: TResponsiveTableState,
  state: TResponsiveTableState,
  focus = state.isFocused,
  target?: HTMLElement,
) {
  focus = focus && table.contains(document.activeElement);

  table.querySelectorAll<HTMLElement>(getFocusSelector()).forEach((e) => {
    e.tabIndex = -1;
  });

  if (state.focusedColumn === 0) {
    const focusedRow = table.querySelector<HTMLElement>(
      `tr[data-rowindex="${state.focusedRow}"]`,
    );
    if (focusedRow) {
      focusedRow.tabIndex = 0;
      window.requestAnimationFrame(() => {
        if (focus) {
          focusedRow.focus();
        }
      });
    }
  } else {
    const focusedCell = table.querySelector(
      `tr[data-rowindex="${state.focusedRow}"] td[aria-colindex="${state.focusedColumn}"], tr[data-rowindex="${state.focusedRow}"] th[aria-colindex="${state.focusedColumn}"]`,
    );

    if (target) {
      target.focus();
    }

    if (focusedCell instanceof HTMLElement) {
      const widgets: HTMLElement[] = [];
      if (state.isEditionMode) {
        widgets.push(
          ...focusedCell.querySelectorAll<HTMLElement>(getFocusSelector()),
        );
      } else {
        const widget =
          focusedCell.querySelector<HTMLElement>(getFocusSelector());
        if (widget) {
          widgets.push(widget);
        }
      }
      if (widgets.length) {
        widgets.forEach((widget, i) => {
          widget.tabIndex = 0;
          if (i === 0)
            window.requestAnimationFrame(() => {
              if (!target && focus) {
                widget.focus();
              }
            });
        });
      } else {
        focusedCell.tabIndex = 0;
        window.requestAnimationFrame(() => {
          if (!target && focus) {
            focusedCell.focus();
          }
        });
      }
    }
  }
}
